// The "Book a demo" action (LANDING_INSPIRATION G4: destination is a
// downstream implementation choice - calendar vs form). The booking surface now
// exists: a 30-minute Cal.com slot with the founders. It is an off-site
// destination, so every render opens it in a new tab (BOOK_DEMO_LINK_PROPS)
// rather than dropping the visitor out of the marketing site. Swap the href
// here if the scheduler moves; every marketing surface reads this constant.

export const BOOK_DEMO_LABEL = 'Book a demo';

export const BOOK_DEMO_HREF = 'https://cal.com/naumu/demo-30-min';

/** Spread onto any anchor rendering BOOK_DEMO_HREF - off-site, new tab, safe rel. */
export const BOOK_DEMO_LINK_PROPS = {
	target: '_blank',
	rel: 'noopener noreferrer',
} as const;
